@if (!isDesktop()) {
  <nav iwMobileNav class="iw-bottom-nav"></nav>
}

<header class="header">
  <iw-header />
</header>

<main class="main">
  @if (me()) {
    <router-outlet></router-outlet>
  } @else {
    <iw-dot-pulse [size]="'l'" />
  }
</main>
